import { Model } from '@psyomics/surveyjs-core';
import { SurveyJs } from '@psyomics/ui-components';
import { useEffect, useRef, useState } from 'react';

import { SurveyResponse } from '../../survey-responses/hooks/use-survey-response';

const skipToEnd = (model: Model) => {
  SurveyJs.navigateToLastAnsweredQuestion(model);
};

const usePrepareSurvey = ({
  model,
  surveyResponse,
  fetchingResponses,
  reviewMode,
}: {
  fetchingResponses: boolean;
  model: Model;
  surveyResponse?: SurveyResponse;
  reviewMode: boolean;
}) => {
  const initialSkipDone = useRef(false);
  const [answersPopulated, setAnswersPopulated] = useState(false);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!initialSkipDone.current && answersPopulated) {
      initialSkipDone.current = true;
      if (!reviewMode) skipToEnd(model);
      setReady(true);
    }
  }, [model, answersPopulated, reviewMode]);

  useEffect(() => {
    if (surveyResponse && !fetchingResponses) {
      model.mergeData(surveyResponse.answers ? JSON.parse(surveyResponse.answers) : {});
      setAnswersPopulated(true);
    }
  }, [surveyResponse, fetchingResponses, model]);

  return ready;
};

export { usePrepareSurvey };
